


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { MathHelper } from '@/helper/mathHelper';
import { PathHelper } from '@/helper/pathHelper';
import { UuidHelper } from '@/helper/uuidHelper';

@Component({
    components: {
    },
})
export default class PolygonLayerDrawer extends Vue {
  
    @Prop() private layer!: PolygonLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    private isRenderComponent : boolean = true;

    private get layerLinearGradationAngle() { return this.layer.linearGradationAngle; }
    @Watch('layerLinearGradationAngle')
    onLayerLinearGradationAngleChanged(val: number, oldVal: number)
    {
        // 一部ブラウザで更新されないことがあるので、強制的に更新
        this.isRenderComponent = false;
        this.$nextTick(() =>
        {
            this.isRenderComponent = true;
        });
    } 

    // ViewのUUID
    private uuid = "";

    mounted() 
    {
       this.uuid = UuidHelper.getUuid();
    }

    // グラデーションタグのID
    private get linearGradientId() : string
    {
        // "linearGradient_" + {UUID}
        return "linearGradient_" + this.uuid;
    }

    private get radialGradientId() : string
    {
        // "radialGradient_" + {UUID}
        return "radialGradient_" + this.uuid;
    }

    private get path()
    {
        var svgPath = PathHelper.createPolygon(this.layer.controlPoints, this.layer.radius);
        var path = new SVGPathData(svgPath);
        // オフセット
        path = path.translate(-this.layer.centerX, -this.layer.centerY);
        // スケーリング
        path = path.scale(this.scale, this.scale);
        // オフセット
        path = path.translate(this.layer.x * this.scale + this.offsetX + this.width / 2, this.layer.y * this.scale + this.offsetY + this.height / 2);

        return path.encode();
    }

    private get x()
    {
        return this.layer.x * this.scale + this.offsetX;
    }

    private get y()
    {
        return this.layer.y * this.scale + this.offsetY;
    }

    private get width()
    {
        return this.layer.width * this.scale;
    }

    private get height()
    {
        return this.layer.height * this.scale;
    }

    private get strokeColor()
    {
        // [線なし]の場合は0、それ以外はレイヤーの線幅設定値を取得
        let layerStrokeWidth = this.layer.noStroke ? 0 : this.layer.strokeWidth;
        // 0.00のときWin/DL版で出力がおかしくなるのに対処
        // 0.00のときは0.001にして、枠線色を塗りつぶしと同じにする
        if(MathHelper.equals(layerStrokeWidth, 0)) return this.fillColor;

        var r = this.layer.strokeColor.r;
        var g = this.layer.strokeColor.g;
        var b = this.layer.strokeColor.b;
        
        return "rgb(" + r + "," + g + "," + b + ")";
    }

    private get opacity()
    {
        return MathHelper.clamp(this.layer.opacity / 100, 0, 1);
    }

    private get strokeWidth()
    {
        // [線なし]の場合は0、それ以外はレイヤーの線幅設定値を取得
        let layerStrokeWidth = this.layer.noStroke ? 0 : this.layer.strokeWidth;
        // 0.00のときWin/DL版で出力がおかしくなるのに対処
        // 0.00のときは0.001にして、枠線色を塗りつぶしと同じにする
        if(MathHelper.equals(layerStrokeWidth, 0)) return 0.001 * this.scale;

        return layerStrokeWidth * this.scale;
    }

    private get fillColor()
    {
        if (this.layer.fillType == 1)
        {
            // 単色
            var r = this.layer.fillColor.r;
            var g = this.layer.fillColor.g;
            var b = this.layer.fillColor.b;

            return "rgb(" + r + "," + g + "," + b + ")";
        }
        else if (this.layer.fillType == 2)
        {
            // グラデーション
            var id = this.layer.gradationType == 1 ? this.radialGradientId : this.linearGradientId;
            return "url(#" + id + ")";
        }
        else
        {
            // なし
            return "none";
        }
    }

    private get transform()
    {
        var transform = "";

        // オフセット
        transform += "translate(" + this.x + " " + this.y + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // 幅・高さによる反転を適用する
        transform += "scale(" + (this.layer.width < 0 ? -1 : 1) + " " + (this.layer.height < 0 ? -1 : 1) + "),";

        // オフセット
        transform += "translate(" + (-this.x) + " " + (-this.y) + ")";

        return transform;
    }

    // グラデーション
    private get gradientStartPoint()
    {
        var x = 0;
        var y = 0;
        if(this.layer.linearGradationAngle > 270)
        {
            x = this.x;
            y = this.y + this.height;
        }
        else if(this.layer.linearGradationAngle > 180)
        {
            x = this.x + this.width;
            y = this.y + this.height;
        }
        else if(this.layer.linearGradationAngle > 90)
        {
            x = this.x + this.width;
            y = this.y;
        }
        else
        {
            x = this.x;
            y = this.y;
        }
        return { x : x, y : y };
    }

    private get gradientEndPoint()
    {
        var dx = 0;
        var dy = 0;
        if(this.layer.linearGradationAngle > 270)
        {
            dx = this.getGradientDelta(90 - (this.layer.linearGradationAngle - 270)).x;
            dy = -this.getGradientDelta(90 - (this.layer.linearGradationAngle - 270)).y;
        }
        else if(this.layer.linearGradationAngle > 180)
        {
            dx = -this.getGradientDelta(this.layer.linearGradationAngle - 180).x;
            dy = -this.getGradientDelta(this.layer.linearGradationAngle - 180).y;
        }
        else if(this.layer.linearGradationAngle > 90)
        {
            dx = -this.getGradientDelta(90 - (this.layer.linearGradationAngle - 90)).x;
            dy = this.getGradientDelta(90 - (this.layer.linearGradationAngle - 90)).y;
        }
        else
        {
            dx = this.getGradientDelta(this.layer.linearGradationAngle).x;
            dy = this.getGradientDelta(this.layer.linearGradationAngle).y;
        }
        return { x : this.gradientStartPoint.x + dx, y : this.gradientStartPoint.y + dy };
    }

    private getGradientDelta(degrees)
    {
        var radian = degrees * Math.PI / 180;
        var x = this.width * Math.cos(radian) * Math.cos(radian) + this.height * Math.sin(radian) * Math.cos(radian);
        var y = this.height * Math.sin(radian) * Math.sin(radian) + this.width * Math.sin(radian) * Math.cos(radian);
        return { x : x, y : y};
    }

    private get linnerGradientInfoArray()
    {
        var array = new Array();
        
        for(var info of this.layer.gradationInfoArray)
        {
            var offset = info.position + "%";
            var r = info.color.r;
            var g = info.color.g;
            var b = info.color.b;
            var a = 1;//MathHelper.clamp(this.layer.opacity / 100, 0, 1);
            var color = "rgb(" + r + "," + g + "," + b + ")";
            array.push({ offset : offset, color : color, opacity : a });
        }

        return array;
    }    

    private get radialGradientCenter()
    {
        var cx = 0.5;
        var cy = 0.5;
        var r = 0.5;
        if(this.layer.radialGradationDirection == 1)
        {
            cx = 0;
            cy = 0;
            r = 1;
        }
        else if(this.layer.radialGradationDirection == 2)
        {
            cx = 1;
            cy = 0;
            r = 1;
        }
        else if(this.layer.radialGradationDirection == 3)
        {
            cx = 1;
            cy = 1;
            r = 1;
        }
        else if(this.layer.radialGradationDirection == 4)
        {
            cx = 0;
            cy = 1;
            r = 1;
        }

        return { x : cx, y : cy, r : r };
    }
}
